module.exports = __webpack_public_path__ + "static/media/box4.5ffa9ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coinbase/box4.png
// module id = 1055
// module chunks = 0